import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import MetalRateStrip from '../components/MetalRateStrip';
import TrustSection from '../components/TrustSection';
import OnboardingModal from '../components/OnboardingModal';

const AboutPage = () => {
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [authModalRole, setAuthModalRole] = useState('buyer');

  const openAuth = (role) => {
    setAuthModalRole(role);
    setAuthModalOpen(true);
  };

  return (
    <div className="app-wrapper">
      <MetalRateStrip />
      <Navbar onOpenAuthModal={openAuth} />

      <main style={{ padding: '60px 0' }}>
        <div className="jmi-container">
          <div className="section-header-center">
            <div className="section-label">ABOUT JEWEL MART INDIA</div>
            <h1 className="section-title">
              Digitising India's <span className="gold-gradient-text">Jewellery Trade</span>
            </h1>
            <p className="section-subtitle">
              JMI (Jewel Mart India), operated by <strong>7RAYS GLOBAL PRIVATE LIMITED (CIN: U47733GJ2026PTC171774)</strong>, was founded to build 
              the digital operating infrastructure for the multi-billion dollar Indian gems and jewellery sector.
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '28px',
            marginBottom: '40px',
          }}>
            <div className="jmi-card">
              <h3 style={{ fontSize: '1.4rem', marginBottom: '14px', color: '#FFFFFF' }}>Our Purpose</h3>
              <p style={{ color: 'var(--text-secondary)', lineHeight: '1.65', fontSize: '0.95rem' }}>
                For centuries, India's wholesale jewellery commerce relied on informal brokers, manual weighment slips, 
                and physical travel with high-risk carriage. JMI introduces digital institutional governance: real-time 
                bullion pricing synchronization, structured B2B variant orders, mandatory BIS hallmarking traceability, 
                and secure vault-to-vault logistics.
              </p>
            </div>

            <div className="jmi-card">
              <h3 style={{ fontSize: '1.4rem', marginBottom: '14px', color: '#FFFFFF' }}>Corporate Governance</h3>
              <p style={{ color: 'var(--text-secondary)', lineHeight: '1.65', fontSize: '0.95rem' }}>
                As an enterprise product of <strong>7RAYS GLOBAL PRIVATE LIMITED</strong>, JMI bridges traditional craftsmanship with modern financial 
                engineering. Headquartered in Surat, Gujarat (395010 - India), we empower manufacturers in regional manufacturing hubs 
                (Surat, Rajkot, Jaipur, Kolkata, Coimbatore) to connect directly with verified retail showrooms nationwide.
              </p>
            </div>
          </div>

          {/* Official Corporate Entity Information Card */}
          <div style={{
            background: 'rgba(16, 16, 17, 0.85)',
            border: '1px solid rgba(212, 175, 55, 0.3)',
            borderRadius: '14px',
            padding: '24px 28px',
            marginBottom: '50px',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '16px',
          }}>
            <div>
              <div style={{ fontSize: '0.75rem', fontFamily: 'var(--font-mono)', color: 'var(--gold-400)', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
                OFFICIAL REGISTERED CORPORATE ENTITY
              </div>
              <div style={{ fontSize: '1.15rem', fontWeight: '700', color: '#FFFFFF', marginTop: '4px' }}>
                7RAYS GLOBAL PRIVATE LIMITED
              </div>
              <div style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', marginTop: '4px' }}>
                Corporate Identification Number (CIN): <strong style={{ color: 'var(--tech-accent)', fontFamily: 'var(--font-mono)' }}>U47733GJ2026PTC171774</strong>
              </div>
            </div>
            <div style={{ fontSize: '0.85rem', color: 'var(--text-muted)', textAlign: 'right' }}>
              <div>Registered Office:</div>
              <div style={{ color: '#FFFFFF', fontWeight: '600' }}>Surat, Gujarat, 395010 - India.</div>
            </div>
          </div>

          <TrustSection />
        </div>
      </main>

      <Footer onOpenAuthModal={openAuth} />
      <OnboardingModal 
        isOpen={authModalOpen} 
        onClose={() => setAuthModalOpen(false)} 
        initialRole={authModalRole} 
      />
    </div>
  );
};

export default AboutPage;
